/**
 * Helpers compartidos entre los subcomponentes de la Ficha Municipal.
 *
 * Sprint 18.4.2 (P1-6 audit, mayo 20, 2026): extraído del antiguo
 * `FichaMunicipal.tsx` (1234 LOC) que mezclaba el orchestrator con
 * todos sus subcomponentes + helpers privados.
 */

/**
 * Devuelve la clase Tailwind de color según el rango del score
 * (verde >=1.1x · ámbar 0.9-1.1x · rojo <0.9x · gris null).
 */
export function scoreColorClass(score: number | null): string {
  if (score === null) return "text-slate-400";
  if (score >= 1.1) return "text-emerald-700";
  if (score >= 0.9) return "text-amber-700";
  return "text-red-700";
}

/**
 * Convierte un Decimal serializado como string ("123456789.00") a BigInt
 * truncando los decimales. Defensivo ante strings vacíos / no numéricos
 * — el backend a veces devuelve "" cuando el muni no tiene captación.
 */
export function bigIntFromCop(amount: string): bigint {
  if (!amount) return 0n;
  const cleaned = amount.replace(/\.[0-9]+$/, "");
  try {
    return BigInt(cleaned || "0");
  } catch {
    return 0n;
  }
}

/**
 * Formato compacto de pesos colombianos para que quepa en cards
 * estrechas: B (billón), MM (mil millones), M (millón), K (mil).
 * Para montos chicos cae a `toLocaleString("es-CO")` con separador.
 */
export function formatCop(amount: bigint): string {
  const n = Number(amount);
  if (n >= 1e12) return `$${(n / 1e12).toFixed(1)}B`;
  if (n >= 1e9) return `$${(n / 1e9).toFixed(2)}MM`;
  if (n >= 1e6) return `$${(n / 1e6).toFixed(0)}M`;
  if (n >= 1e3) return `$${(n / 1e3).toFixed(0)}K`;
  return `$${n.toLocaleString("es-CO")}`;
}
